document.addEventListener("DOMContentLoaded", function() {
  const description = document.getElementById("collectionDescription");
  const toggleButton = document.getElementById("toggleButton");

  if (description && toggleButton) {
    const isOverflowing = description.scrollHeight > description.clientHeight;
    if (!isOverflowing) {
      toggleButton.style.display = "none";
    }

    toggleButton.addEventListener("click", function() {
      description.classList.toggle("expanded");

      if (description.classList.contains("expanded")) {
        toggleButton.textContent = "Read Less";
      } else {
        toggleButton.textContent = "Read More";
      }
    });
  }
});